import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Col, Container, Row } from "reactstrap";
import BaseInput from "../../../../toolkit/baseInput";
import ModalFrame from "../../../../toolkit/modalFrame";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import {
  associatePromotion,
  associateAltPromotion
} from "../../../actions/partners";
import { Partner } from "../interfaces";
import s from "../styles.scss";

interface Props {
  partner: Partner;
  isOpen: boolean;
  promociones: any[];
  cancel: () => any;
  success: () => any;
}

interface State {
  selectedTipo: String;
  selectedPromocionId: number;
  permitePromoAlterna: boolean;
  selectedPromocionAltId: number;
  beneficioMultiple: boolean;
  selectedPromocionBenefId: number;
  promocionesFiltered: any[];
  beneficiosPromocion: any[];
  saving: boolean;
}

class PromotionAssociationModal extends React.Component<Props, State> {
  state = {
    selectedTipo: null,
    selectedPromocionId: null,
    permitePromoAlterna: false,
    selectedPromocionAltId: null,
    beneficioMultiple: false,
    selectedPromocionBenefId: null,
    promocionesFiltered: [],
    beneficiosPromocion: [],
    saving: false
  };

  componentDidMount() {}

  handleSubmit = async () => {
    const {
      selectedPromocionId,
      selectedPromocionAltId,
      permitePromoAlterna,
      beneficioMultiple,
      selectedPromocionBenefId
    } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    if (
      !!beneficioMultiple &&
      (!selectedPromocionBenefId || selectedPromocionBenefId == "NA")
    ) {
      errorNotification(
        "Debe seleccionar un beneficio de descuento para producto"
      );
      return;
    }

    await this.setState({ saving: true });

    infoNotification("Aplicando promoción...");

    try {
      const execution1 = await associatePromotion(
        idMembresiaSocio,
        selectedPromocionId,
        !!selectedPromocionBenefId && !selectedPromocionAltId
          ? selectedPromocionBenefId
          : null
      );

      if (!!selectedPromocionAltId) {
        const execution2 = await associateAltPromotion(
          idMembresiaSocio,
          selectedPromocionAltId,
          !!selectedPromocionBenefId ? selectedPromocionBenefId : null
        );
      }

      successNotification("Promoción aplicada correctamente");
      this.setState({
        selectedTipo: null,
        selectedPromocionId: null,
        selectedPromocionAltId: null,
        promocionesFiltered: [],
        saving: false
      });
      this.props.success();
    } catch (error) {
      errorNotification("Error al asociar la promoción");
      await this.setState({ saving: false });
    }
  };

  hanldeChangeTipo = (tipo: string) => {
    if (!tipo) {
      this.setState({ promocionesFiltered: [] });
      return;
    }

    const { promociones } = this.props;
    const filtered = (promociones || []).filter(
      x => x.tipoUsoPromocion == tipo
    );
    this.setState({
      selectedTipo: tipo,
      promocionesFiltered: filtered,
      selectedPromocionId: null,
      selectedPromocionAltId: null
    });
  };

  handleCancel = () => {
    this.setState({ selectedTipo: null, selectedPromocionId: null });
    this.props.cancel();
  };

  render() {
    return (
      <ModalFrame
        title={`Asociación de promoción`}
        isOpen={this.props.isOpen}
        toggle={() => {}}
        size={"md"}
      >
        <Container style={{ width: "90%" }} className="center-block p-0 mb-3">
          <div>
            <BaseInput
              type="select"
              id="iTipoPromocion"
              name="iTipoPromocion"
              label={"Tipo"}
              value={this.state.selectedTipo}
              onChange={e => {
                const value = e.target.value;
                this.setState({ selectedTipo: value });
                this.hanldeChangeTipo(value);
              }}
              options={[{ value: null, label: "Seleccione" }].concat([
                { value: "VENTA", label: "VENTA" },
                { value: "REACTIVACION", label: "REACTIVACION" }
              ])}
            />
          </div>
          <div>
            <BaseInput
              type="select"
              id="iPromocionId"
              name="iPromocionId"
              label={"Promoción"}
              value={this.state.selectedPromocionId}
              onChange={e => {
                const value = e.target.value;
                const promo = this.state.promocionesFiltered.find(
                  x => x.id == value
                );
                if (!!promo) {
                  const permitePromoAlterna = !!promo.permitePromoAlterna;
                  const beneficioMultiple = !!promo.beneficioProdOpcionMultiple;
                  const beneficiosPromocion = beneficioMultiple
                    ? promo.beneficiosProductos
                    : [];

                  this.setState({
                    selectedPromocionId: value,
                    permitePromoAlterna,
                    selectedPromocionAltId: null,
                    beneficioMultiple,
                    selectedPromocionBenefId: null,
                    beneficiosPromocion: [...beneficiosPromocion]
                  });
                } else {
                  this.setState({
                    selectedPromocionId: null,
                    permitePromoAlterna: false,
                    selectedPromocionAltId: null,
                    beneficioMultiple: false,
                    selectedPromocionBenefId: null,
                    beneficiosPromocion: []
                  });
                }
              }}
              options={[{ value: 0, label: "Seleccione" }].concat(
                (this.state.promocionesFiltered || [])
                  .filter(x => !!x.principal)
                  .map(x => {
                    return { value: x.id, label: x.nombre };
                  })
              )}
            />
          </div>
          {!!this.state.selectedPromocionId &&
            !!this.state.permitePromoAlterna && (
              <div>
                <BaseInput
                  type="select"
                  id="iPromocionIdAlt"
                  name="iPromocionIdAlt"
                  label={"Promoción Alterna"}
                  value={this.state.selectedPromocionAltId}
                  onChange={e => {
                    const value = e.target.value;
                    const promo = this.state.promocionesFiltered.find(
                      x => x.id == value
                    );

                    if (!!promo) {
                      const beneficioMultiple = !!promo.beneficioProdOpcionMultiple;
                      const beneficiosPromocion = beneficioMultiple
                        ? promo.beneficiosProductos
                        : [];

                      this.setState({
                        selectedPromocionAltId: value,
                        beneficioMultiple,
                        selectedPromocionBenefId: null,
                        beneficiosPromocion: [...beneficiosPromocion]
                      });
                    } else {
                      this.setState({
                        selectedPromocionAltId: null,
                        beneficioMultiple: false,
                        selectedPromocionBenefId: null,
                        beneficiosPromocion: []
                      });
                    }
                  }}
                  options={[{ value: 0, label: "Seleccione" }].concat(
                    (this.state.promocionesFiltered || [])
                      .filter(
                        x =>
                          x.id != this.state.selectedPromocionId && !!x.alterna
                      )
                      .map(x => {
                        return { value: x.id, label: x.nombre };
                      })
                  )}
                />
              </div>
            )}

          {!!this.state.selectedPromocionId && !!this.state.beneficioMultiple && (
            <div>
              <BaseInput
                type="select"
                id="beneficioProdOpcionMultiple"
                name="beneficioProdOpcionMultiple"
                label={"Seleccionar beneficio"}
                value={this.state.selectedPromocionBenefId}
                onChange={e => {
                  const value = e.target.value;
                  this.setState({ selectedPromocionBenefId: value });
                }}
                options={[{ label: "Sin beneficio", value: "NA" }].concat(
                  (this.state.beneficiosPromocion || []).map(b => {
                    return {
                      label: b.productoNombre + " - " + b.descuento,
                      value: b.id
                    };
                  })
                )}
              />
            </div>
          )}

          <div className="mt-3 mb-3" style={{ fontStyle: "bold" }}>
            <span>
              Nota: Se aplicarán los beneficios de invitados gratis y pases de
              invitado gratis correspondientes a la promoción
            </span>
          </div>

          <Row className="m-0">
            <Col xs="12" md="5">
              <Button
                className={`mt-3 primaryButton`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.handleSubmit();
                }}
                block
                disabled={
                  !this.state.selectedTipo ||
                  !this.state.selectedPromocionId ||
                  !!this.state.saving
                }
              >
                Guardar
              </Button>
            </Col>
            <Col xs="12" md="2"></Col>
            <Col xs="12" md="5">
              <Button
                className={` mt-3`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.handleCancel();
                }}
                block
                disabled={!!this.state.saving}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default withStyles(s)(PromotionAssociationModal);
